<div class="flip-container" [class.flipped]="flipped()">
  <div class="front">
    <ng-content select="[flipFront]"></ng-content>
  </div>
  <div class="back">
    <ng-content select="[flipBack]"></ng-content>
  </div>
</div>
